import i18nProvider from '../../common/services/i18n.provider';
import LanguageHttpInterceptor from '../../common/services/language.http-interceptor.service';
import TerritoryProvider from '../../common/services/territory.provider';
import NoAuthPackagesService from './noauth-packages.service';
import NoAuthService from './noauth.service';
import StorageService from './storage.service';
import UserInfoService from './user-info.service';

export default angular
  .module('fizyweb.paycell.noauth.services', [])
  .service('noAuthService', NoAuthService)
  .service('noAuthPackagesService', NoAuthPackagesService)
  .service('storageService', StorageService)
  .service('userInfoService', UserInfoService)
  .factory('languageHttpInterceptor', LanguageHttpInterceptor)
  .provider('i18n', i18nProvider)
  .provider('territory', TerritoryProvider).name;



// WEBPACK FOOTER //
// src/app/no-auth/services/services.module.ts